import { SET_SELECTED_CALENDAR_DATE } from 'actions';

export function setSelectedCalendarDate(selectedCalendarDate: string) {
  return { selectedCalendarDate, type: SET_SELECTED_CALENDAR_DATE };
}
